export enum RAuditType {
	BULK_SCHEDULED = 'BULK_SCHEDULED',
	BULK_UNSCHEDULED = 'BULK_UNSCHEDULED',
	CRON_ACTIVATED = 'CRON_ACTIVATED',
	CRON_DEACTIVATED = 'CRON_DEACTIVATED',
	WORKFLOW_START = 'WORKFLOW_START',
}
